export default class Common
{
    public static isNullOrWhiteSpace(value: string | null | undefined)
    {
        return value === null || value?.toString().match(/^ *$/) !== null;
    }

    public static newGuid()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c)
        {
            // eslint-disable-next-line
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
